import { useState, useCallback } from 'react';
import { loadSettings, saveSettings, POSSettings } from '@/lib/posStorage';

export function usePOSSettings() {
  const [settings, setSettingsState] = useState<POSSettings>(() => loadSettings());

  const setSettings = useCallback((next: POSSettings) => {
    setSettingsState(next);
    saveSettings(next);
  }, []);

  const updateSettings = useCallback((partial: Partial<POSSettings>) => {
    setSettingsState((prev) => {
      const next = { ...prev, ...partial };
      saveSettings(next);
      return next;
    });
  }, []);

  return { settings, setSettings, updateSettings };
}
